// This reducer is currently only used for Previewing
import {
  GET_STORY,
  GET_STORY_SUCCESS,
  GET_STORY_ERROR,
} from "../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STORY: {
      return {
        ...state,
        isLoading: false,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_STORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: [action.payload],
      };

    case GET_STORY_ERROR:
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };

    default: {
      return state;
    }
  }
};
